import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import { useTranslation } from "../../context/Internationalization";
import IconButton from "@mui/material/IconButton";
import useStyles from "./modalStyles";
import DeleteModalIcon from "../../assets/images/Svg/DeleteModalIcon";
import VerificationIcon from "../../assets/images/payment-icon/verification-icon.svg";

const InfoIcon = () => (
  <img
    src={VerificationIcon}
    width={66}
    height={66}
    alt=""
    aria-hidden="true"
  />
);

const ModalHeader = ({ type, onClose, closeLabel, hideIcon = false }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const Icon = type === "info" ? InfoIcon : DeleteModalIcon;

  return (
    <Box className={styles.modalHeader}>
      {!hideIcon && (
        <Box sx={{ gridColumn: 2, justifySelf: "center", lineHeight: 0 }}>
          <Icon />
        </Box>
      )}
      <IconButton
        className={styles.modalCloseButton}
        onClick={onClose}
        aria-label={closeLabel || t("close")}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

ModalHeader.propTypes = {};

export default ModalHeader;
